@if (cardDetails) {
  <app-block-confirmation
    [cardDetail]="cardDetails"
    title="Block employee card">
    @if (cardDetails.holder; as holder) {
      <ng-container specifyCard>
        <div class="h4 mt-5">{{ holder.first_name }} {{ holder.last_name }}'s card has been permanently blocked.</div>
      </ng-container>
    }
  </app-block-confirmation>
}
